import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '../services/config.service';
import * as crypto from 'crypto-js'
import { SESSION_STORAGE, WebStorageService } from 'angular-webstorage-service';
// import { CommonUtilities } from '../shared-data';

@Injectable()
export class HttpService {

  headers: HttpHeaders | { [header: string]: string | string[]; };
  options: any;

  constructor(private http: HttpClient,
              private configService: ConfigService,
              @Inject(SESSION_STORAGE) private storage: WebStorageService
            ) {}

  addUserIdAndLang(params: any = {} as any){
    const session = this.storage.get('login');
    const userId =  session ? session.data.info.id : null;

    if(userId){
      if( params instanceof FormData){
        params.append('userId', userId);
        if(!params.has('lang')){
          params.append('lang', this.configService.lang);
        }
      }else {
        params['userId'] = userId;
        if(!Object.keys(params).includes('lang')){
          params['lang'] = this.configService.lang;
        }
      }
    }
    return params;
  }

  get(api: any, param: any): Promise<any> {
    try {
      // params.channel_id = 3;
      param = this.addUserIdAndLang(param);
      const params = JSON.parse(JSON.stringify(param));
      const url = this.configService.PROXIES.sport_admin_services + api + this.parseParams(params);
      for (const key in params) {
        if (params.hasOwnProperty(key)) {
          params[key] = encodeURIComponent(params[key]);
        }
      }
      return new Promise((resolve, reject) => {
        this.http.get(url, {
          headers: {
            Accept: 'application/json',
          }
        })
          .subscribe(data => {
            resolve(data);
          }, error => {
            reject(error);
          });
      });
    } catch (err) {
      return new Promise(reject => {
        reject(err);
      });
    }
  }

  get_no_auth(url: any, params: any): Promise<any> {
    // params.channel_id = 2;

    try {
      params = this.addUserIdAndLang(params);
      document.body.style.cursor = 'wait';
      url = url + this.parseParams(params);
      return new Promise((resolve, reject) => {
        this.http.get(url)
          .subscribe(data => {
            document.body.style.cursor = 'default';
            resolve(data);
          }, error => {
            document.body.style.cursor = 'default';
            reject(error);
          });
      });
    } catch (err) {
      return new Promise(reject => {
        reject(err);
      });
    }
  }

  _get(api: any, params: any): Promise<any> {
    // params.channel_id = 2;

    this.setHeaders('withToken');
    try {
      params = this.addUserIdAndLang(params);
      const url = api + this.parseParams(params);
      return new Promise((resolve, reject) => {
        this.http.get(url, {
          headers: {
            Accept: 'application/json',
            Authorization: 'Bearer 084678ad-2f42-4e5a-954f-dbe675f4b1d5'
          }
        })
          .subscribe(data => {
            resolve(data);
          }, error => {
            resolve(error);
          });
      });
    } catch (err) {
      return new Promise(reject => {
        reject(err);
      });
    }
  }

  //used
  __get(api: any, params: any): Promise<any> {
    try {
      params = this.addUserIdAndLang(params);
      const url = api + this.parseParams(params);
      return new Promise((resolve, reject) => {
        this.http.get(url, {
          headers: {
            Accept: 'application/json',
          }
        })
          .subscribe(data => {
            resolve(data);
          }, error => {
            resolve(error);
          });
      });
    } catch (err) {
      return new Promise(reject => {
        reject(err);
      });
    }
  }

  // used
  Hget(host: any, api: any, param: any, secured = false): Promise<any> {
    // params.channel_id = 3;
    param = this.addUserIdAndLang(param);
    const me = this;
    const params = JSON.parse(JSON.stringify(param));
    var options = {}

    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        params[key] = encodeURIComponent(params[key]);
      }
    }

    if(secured) {
      const headers = this.getHeaders('', api, this.parseAuthParams(params));
      options = { headers }
    }


    const url = host + api + this.parseParams(params);

    // console.debugerror("url", url);
    return new Promise((resolve, reject) => {
      this.http.get(url, options)
        .subscribe(data => {
          // console.debugerror("data",JSON.stringify(data));
          resolve(data);
        }, error => {
          // console.debugerror("data",JSON.stringify(error));
          resolve(error);

        });

    });
  }


  buildPathParams(params: Array<any>): any {
    return params.map(param => "/" + param).join("");
  }

  parseParams(data: any): any {
    const arr = Object.keys(data);
    let queryParams = arr.length > 0 ? '?' : '';
    for (let i = 0; i < arr.length; i++) {
      queryParams = queryParams + arr[i] + '=' + data[arr[i]] + (i<arr.length-1 ? '&' : "");
    }
    return queryParams;
  }

  parseAuthParams(data: any): any {
    const arr = Object.keys(data);
    let queryParams = '';
    for (let i = 0; i < arr.length; i++) {
      queryParams = queryParams + arr[i] + '=' + data[arr[i]] + (i<arr.length-1 ? '&' : "");
    }
    return queryParams;
  }


  /************************Post Request*******************************/

  // used
  post_request(host: any, api: any, params: any, secured = false): Promise<any> {
    this.headers = new HttpHeaders();
    this.headers.append('Content-Type', 'application/json');
    // params = this.parseAuthParams(params);
    params = this.addUserIdAndLang(params);
    const url = host + api;
    var options: any = {};
    if(secured) {
      const headers = this.getHeaders("", api, params instanceof FormData ? '' : JSON.stringify(params));
      options = { headers };
    }

    return new Promise((resolve, reject) => {
      this.http.post(url, params, options)
        .subscribe(data => {
          resolve(data);
        }, error => {
          resolve(error);
        });
    });
  }

  // used
  PostRequest(host: any, api: any, params: any): Promise<any> {
    this.headers = new HttpHeaders();
    this.headers.append('Content-Type', 'application/json');
    params = this.addUserIdAndLang(params);
    const me = this;
    const url = host + api;
    return new Promise((resolve, reject) => {
      this.http.post(url, params)
        .subscribe(data => {
          resolve(data);
        }, error => {
          resolve(error);
        });
    });
  }

  // used
  PostAuth(host: string, api: string, params: any): Promise<any> {
    params = this.addUserIdAndLang(params);
    const url = host + api;
    const headers = this.getHeaders("", api, JSON.stringify(params));
    const options: any = { headers };
    return new Promise((resolve, reject) => {
      this.http.post(url, params, options).subscribe(
        data => resolve(data),
        error => resolve(error)
      )
    })
  }

  // used
  PostAuthParams(host: string, api: string, params: any): Promise<any> {
    params = this.addUserIdAndLang(params);
    const url = host + api + this.parseParams(params);
    const headers = this.getHeaders("", api, this.parseParams(params).split('?')[1]);

    const options: any = {headers};
    return new Promise((resolve, reject) => {
      this.http.post(url, null, options).subscribe(
        data => resolve(data),
        error => resolve(error)
      )
    })
  }

  // used
  _post(host: any, param: any): Promise<any> {
    // params.channel_id = 3;
    param = this.addUserIdAndLang(param);
    const me = this;
    const params = JSON.parse(JSON.stringify(param));
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        params[key] = encodeURIComponent(params[key]);
      }
    }
    const url = host + this.parseParams(params);
    // console.debugerror("url", url);
    return new Promise((resolve, reject) => {
      this.http.post(url, {

      })
        .subscribe(data => {
          // console.debugerror("data",JSON.stringify(data));
          resolve(data);
        }, error => {
          // console.debugerror("data",JSON.stringify(error));
          resolve(error);

        });

    });
  }

  //
  postFileUpload(host: any, api: any, params: any, formData?: any): Promise<any> {
    // params.channel_id = 2;
    params = this.addUserIdAndLang(params);
    const url = host + api;
    return new Promise((resolve, reject) => {
      this.http.post(url, formData)
        .subscribe(data => {
          resolve(data);
        }, error => {
          reject(error);
        });
    });
  }

  // ajax_post

  // used
  Post(url: any, params: any): Promise<any> {
    // params.channel_id = 2;
    // params.channel = 2;
    let queryParam = Array.isArray(params);

    if(!url.includes(this.configService.ServiceUrls.login)){
      if(queryParam){
        url = url + this.parseParams(this.addUserIdAndLang({lang: this.configService.lang}));
      }else {
        params = this.addUserIdAndLang(params);
      }
    } else {
      if(queryParam){
        url = url + this.parseParams({lang: this.configService.lang});
      }else {
        params = {...params, lang: this.configService.lang};
      }
    }

    const me = this;
    return new Promise((resolve, reject) => {
      this.http.post(url, params)
        .subscribe(data => {
          resolve(data);
        }, error => {
          reject(error);
        });
    });
  }
  Patch(url: any, params: any): Promise<any> {
    params = this.addUserIdAndLang(params);
    params.channel = 2;
    const me = this;
    return new Promise((resolve, reject) => {
      this.http.patch(url, params)
        .subscribe(data => {
          resolve(data);
        }, error => {
          reject(error);
        });
    });
  }

  // used
  Put(url: any, params: any): Promise<any> {
    params = this.addUserIdAndLang(params);
    const me = this;
    return new Promise((resolve, reject) => {
      this.http.put(url, params)
        .subscribe(data => {
          resolve(data);
        }, error => {
          reject(error);
        });
    });
  }

  // used
  PutAuth(host: string, api: string, params: any, body = true): Promise<any> {
    params = this.addUserIdAndLang(params);
    const me = this;
    const url = host + api;
    // params = this.parseAuthParams(params);
    const headers = body ? this.getHeaders("", api, params instanceof FormData ? '' : JSON.stringify(params)) :
                          this.getHeaders("", api, "");
    const options: any = {headers};

    return new Promise((resolve, reject) => {
      this.http.put(url, params, options)
        .subscribe(data => {
          resolve(data);
        }, error => {
          reject(error);
        });
    });
  }

  Post_no_auth(url: any, params: any): Promise<any> {
    //   params.token = CommonUtilities.getSessionStorage('token');
    params = this.addUserIdAndLang(params);
    document.body.style.cursor = 'wait';
    return new Promise((resolve, reject) => {
      this.http.post(url + this.parseParams(params), params) //{headers:headers}
        .subscribe(data => {
          resolve(data);
          document.body.style.cursor = 'default';
        }, error => {
          resolve(error);
          document.body.style.cursor = 'default';
        });
    });
  }


  // used
  PUT_NO_AUTH(url: any, params: any): Promise<any> {
    params = this.addUserIdAndLang(params);
    this.setHeaders('');
    // params.token =  CommonUtilities.getSessionStorage('token');
    const me = this;
    document.body.style.cursor = 'wait';
    return new Promise((resolve, reject) => {
      this.http.put(url, params, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer 084678ad-2f42-4e5a-954f-dbe675f4b1d5'
        }
      })
        .subscribe(data => {
          document.body.style.cursor = 'default';
          resolve(data);
        }, error => {
          document.body.style.cursor = 'default';
          // console.debugerror("data",JSON.stringify(error));
          resolve(error);
        });
    });
  }

  // used
  PutAuthParams(host: string, api: string, params: any): Promise<any> {
    params = this.addUserIdAndLang(params);
    const url = host + api + this.parseParams(params);
    const headers = this.getHeaders("", api, this.parseParams(params).split('?')[1]);

    const options: any = {headers};
    return new Promise((resolve, reject) => {
      this.http.put(url, null, options).subscribe(
        data => resolve(data),
        error => resolve(error)
      )
    })
  }



  ajax_post(url, params) {
    const token = '084678ad-2f42-4e5a-954f-dbe675f4b1d5';
    try {
      const xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200) {
          return Promise.resolve(this.responseText);

        }
      };
      xhttp.open('POST', url, true);
      xhttp.send(params);

      // return $.ajax({
      //     url: url,
      //     type: 'POST',
      //     dataType: 'json',
      //     headers: {
      //         'Authorization': 'Bearer ' + token,
      //     },
      //     data: params,
      // });
    } catch (error) {
      console.error('Error', error);
    }
  }

  HgetBlob(host: any, api: any, secured = false): Promise<Blob> {
    const url = host + api;
    const options: any = { responseType: 'blob' as 'json' };
    if (secured) {
      options.headers = this.getHeaders('', api, '');
    }
    return new Promise((resolve, reject) => {
      this.http.get(url, options).subscribe(
        (data: any) => resolve(data as Blob),
        error => reject(error)
      );
    });
  }

  host_delete(host: any, api: any, param: any): Promise<any> {
    const me = this;
    const url = host + api + '/' + param;
    // console.debugerror("url",url);
    return new Promise((resolve, reject) => {
      this.http.delete(url, me.options)
        .subscribe(data => {
          // console.debugerror("data",JSON.stringify(data));
          resolve(data);
        }, error => {
          // console.debugerror("data",JSON.stringify(error));
          resolve(error);

        });

    });
  }

  setHeaders(type): void {
    this.headers = new HttpHeaders();
    // let token = this.shared.token ? this.shared.token: "084678ad-2f42-4e5a-954f-dbe675f4b1d5";
    const token = '084678ad-2f42-4e5a-954f-dbe675f4b1d5';
    this.headers.append('Content-Type', 'application/json');
    this.headers.append('Accept', 'application/json');
    if (type === 'withToken') {
      this.headers.append('Authorization', 'Bearer ' + token);
    }
    this.options = {
      headers: this.headers
    };
  }

  getHeaders(type, url, params) {
    return new HttpHeaders({
      'Content-Signature': this.configService.AuthParams.username + ':' + this.getBase64Hash(this.configService.AuthParams.username + url + params)
    });
  }

  getBase64Hash(params: string) {
    const hash = crypto.HmacSHA256(params, this.configService.AuthParams.RequestHmacKey);
    return crypto.enc.Base64.stringify(hash);
  }
}
